export default function initInTheMaking() {
  const sections = document.querySelectorAll(".in-the-making-section");
  if (!sections.length) return;

  sections.forEach((section) => {
    const tiles = section.querySelectorAll(".article-tile[data-itm-index]");
    const modal = document.querySelector("#itmModal");
    if (!modal || !tiles.length) return;

    const modalTitle = modal.querySelector(".itm-modal-title");
    const modalDate = modal.querySelector(".itm-modal-date");
    const modalContent = modal.querySelector(".itm-modal-content");
    const closeButton = modal.querySelector(".modal-close");

    function openModal(tile) {
      const title = tile.querySelector("h4")?.textContent?.trim() || "";
      if (modalTitle) modalTitle.textContent = title;

      const date = tile.querySelector(".desc > span")?.textContent?.trim() || "";
      if (modalDate) modalDate.textContent = date;

      const template = tile.querySelector("template.itm-content");
      if (modalContent && template) {
        modalContent.innerHTML = template.innerHTML;
      }

      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.classList.add("modal-open");
      document.body.style.overflow = "hidden";
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }

      modal.style.display = "flex";
      setTimeout(() => modal.classList.add("show"), 10);
    }

    function closeModal() {
      modal.classList.remove("show");
      setTimeout(() => {
        modal.style.display = "none";
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }, 150);
    }

    tiles.forEach((tile) => {
      const imageLink = tile.querySelector(".image");
      const viewLink = tile.querySelector(".itm-view");

      [imageLink, viewLink].forEach((el) => {
        if (!el) return;
        el.addEventListener("click", (e) => {
          e.preventDefault();
          openModal(tile);
        });
      });
    });

    closeButton?.addEventListener("click", (e) => {
      e.preventDefault();
      closeModal();
    });

    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.classList.contains("show")) {
        closeModal();
      }
    });
  });
}
